export default __webpack_public_path__ + "static/media/ico-facebook.536016dc.svg";